import React from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
import Loading from './components/Loading';
import AuthRoute from './utils/AuthRoute';
import './scss/style.scss';

const loading = <Loading/>;

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const ChangePsw = React.lazy(() => import('./views/Pages/ChangePsw/ChangePsw'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

export default () => (
    <HashRouter>
        <React.Suspense fallback={loading}>
            <Switch>
                <Route exact path="/login" name="Login Page" component={Login}/>
                <Route exact path="/404" name="Page 404" component={Page404}/>
                <Route exact path="/500" name="Page 500" component={Page500}/>
                <AuthRoute exact path="/change-password" name="Change Password" component={ChangePsw}/>
                <AuthRoute path='/' component={TheLayout}/>
            </Switch>
        </React.Suspense>
    </HashRouter>
);
